<script>
    import { metaInfo } from "@/core/MetaInfo";
    import StoreContent from "@/components/StoreContent";

    export default {
        name: "Store",
        components: { StoreContent },
        computed: {
            sliderOptions() {
                return {
                    isScrollbar: false,
                    isBullets: true,
                    isArrow: true,
                    arrowPosition: "bottom",
                };
            },
        },
        metaInfo() {
            return metaInfo.getMeta("store");
        },
    };
</script>

<template>
    <store-content
        class="store-content"
        catalog-button-text="Выбрать товары"
        :slider-options="sliderOptions"
        :slides-count="{ msk: 4, spb: 4, ekb: 4, krd: 5 }"
        icon="navigation"
    >
        <template #subtitle>
            Приходите в&nbsp;магазины Madrobots. Наши консультанты с&nbsp;удовольствием ответят
            на&nbsp;ваши вопросы.
        </template>
        <template #description-title>Zavtra и Madrobots</template>
        <template #description-subtitle>
            <a href="https://madrobots.ru/" target="_blank">Madrobots.ru</a> — оператор
            официального интернет-магазина Zavtra в России.
        </template>
        <template #description-text>
            Приходите в&nbsp;гости! Вы&nbsp;можете заранее сделать заказ, ближе познакомиться
            с&nbsp;товарами в&nbsp;магазине&nbsp;&mdash; и&nbsp;приобрести подходящие.
        </template>
    </store-content>
</template>

<style lang="scss">
    .store-content {
        .store-shop__slider {
            .c-slider__bottom-wrapper {
                display: flex;
            }
            .c-slider__arrow {
                display: none;
                @include bp($bp-desktop-sm) {
                    display: block;
                }
            }
        }

        .store-description__text-wrapper {
            padding-bottom: 180px;
            @include bp($bp-desktop-sm) {
                padding-bottom: 0;
            }
        }

        .store-description__text {
            max-width: 580px;
        }

        .store-description__decors {
            top: -10px;
            @include bp($bp-desktop-sm) {
                top: -80px;
            }
            @include bp($bp-desktop-md) {
                top: -110px;
            }
        }

        .store-description__decor {
            @media screen and (max-width: 991px) {
                &.decor-left {
                    left: auto;
                    right: calc(50% - 26px);
                }
                &.decor-right {
                    right: auto;
                    left: calc(50% - 26px);
                }
            }
        }
    }
</style>
